document.addEventListener('DOMContentLoaded', function () {
  // Desktop/Tablet Navigation Selectors
  const subnavLinks = document.querySelectorAll('.proxy-subnav a');
  const secondaryNavLinks = document.querySelectorAll(
    '.secondary-nav .list-menu .header__menu-item[data-link-text="menu:level2"], ' +
      '.secondary-nav .mega-menu__link[data-link-text="menu:level4:groupedLinks"], ' +
      '.secondary-nav .mega-menu__link[data-link-text="menu:level3:groupedLinks"], ' +
      '.secondary-nav .mega-menu__link[data-link-text="menu:level3:featuredLinks"]',
  );
  const megaMenuQuickLinks = document.querySelectorAll(
    '.secondary-nav .mega-menu__link[data-link-text="menu:level3:quickLinks"]',
  );
  const level1MenuItems = document.querySelectorAll('.header__menu-item[data-link-text="menu:level1"]');

  // Mobile Menu Drawer Selectors - Get all navigable items (links and summaries)
  const mobileMenuLinks = document.querySelectorAll(
    '.menu-drawer__menu-item[data-link-text="menu:level1"][href], ' +
      '.menu-drawer__menu-item[data-link-text="menu:level2"][href], ' +
      '.menu-drawer__menu-item[data-link-text="menu:level3"][href], ' +
      '.menu-drawer__menu-item[data-link-text="menu:level3:groupedLinks"][href], ' +
      '.menu-drawer__menu-item[data-link-text="menu:level4:groupedLinks"][href], ' +
      '.menu-drawer__menu-item[data-link-text="menu:level3:groupedLinks:open"][href], ' +
      // Include ALL summary tags (including :open ones, but exclude :close)
      'summary.menu-drawer__menu-item[data-link-text^="menu:"]:not([data-link-text*=":close"])',
  );
  const mobileLevel1Links = document.querySelectorAll(
    '.menu-drawer__menu-item[data-link-text="menu:level1"][href], summary.menu-drawer__menu-item[data-link-text^="menu:level1"]:not([data-link-text*=":close"])',
  );

  let isProcessing = false;

  // Session storage keys
  const STORAGE_KEYS = {
    ACTIVE_MENU: 'activeMenu',
    ACTIVE_SUBMENU: 'activeSubMenu',
    ACTIVE_MENU_PARENT: 'activeMenuParent',
    ACTIVE_URL: 'activeUrl',
    ACTIVE_LINK_TYPE: 'activeLinkType',
  };

  // We detect once whether this page originally had menu params
  const initialUrlParams = new URLSearchParams(window.location.search);
  const hadMenuParamsOnLoad =
    initialUrlParams.has('menu') || initialUrlParams.has('submenu') || initialUrlParams.has('menuheader');

  // We only want to do the "full param-driven highlight" once per load
  let initialHighlightDone = false;

  // Navigation tracking for back/forward detection
  let navigationCount = 0;

  // ---------- Session Storage Helpers ----------

  function clearNavigationStorage() {
    try {
      sessionStorage.removeItem(STORAGE_KEYS.ACTIVE_MENU);
      sessionStorage.removeItem(STORAGE_KEYS.ACTIVE_SUBMENU);
      sessionStorage.removeItem(STORAGE_KEYS.ACTIVE_MENU_PARENT);
      sessionStorage.removeItem(STORAGE_KEYS.ACTIVE_URL);
      sessionStorage.removeItem(STORAGE_KEYS.ACTIVE_LINK_TYPE);
      // eslint-disable-next-line no-unused-vars
    } catch (e) {
      // ignore
    }
  }

  function saveMenuState(menuHandle) {
    try {
      sessionStorage.setItem(STORAGE_KEYS.ACTIVE_MENU, menuHandle);
      // eslint-disable-next-line no-unused-vars
    } catch (e) {
      // ignore
    }
  }

  function saveSubmenuState(submenuHandle, parentHandle) {
    try {
      sessionStorage.setItem(STORAGE_KEYS.ACTIVE_SUBMENU, submenuHandle);
      if (parentHandle) {
        sessionStorage.setItem(STORAGE_KEYS.ACTIVE_MENU_PARENT, parentHandle);
      }
      // eslint-disable-next-line no-unused-vars
    } catch (e) {
      // ignore
    }
  }

  function getStoredMenuState() {
    try {
      return {
        menu: sessionStorage.getItem(STORAGE_KEYS.ACTIVE_MENU),
        submenu: sessionStorage.getItem(STORAGE_KEYS.ACTIVE_SUBMENU),
        parent: sessionStorage.getItem(STORAGE_KEYS.ACTIVE_MENU_PARENT),
        url: sessionStorage.getItem(STORAGE_KEYS.ACTIVE_URL),
        linkType: sessionStorage.getItem(STORAGE_KEYS.ACTIVE_LINK_TYPE),
      };
      // eslint-disable-next-line no-unused-vars
    } catch (e) {
      return { menu: null, submenu: null, parent: null, url: null, linkType: null };
    }
  }

  function shouldClearStorageForUrlMismatch() {
    try {
      const storedUrl = sessionStorage.getItem(STORAGE_KEYS.ACTIVE_URL);
      const currentPath = window.location.pathname;

      // If no stored URL, nothing to clear
      if (!storedUrl) {
        return false;
      }

      // If URLs don't match, we've navigated away - clear storage
      if (storedUrl !== currentPath) {
        return true;
      }

      return false;
    } catch {
      return false;
    }
  }
  // ---------- Helpers ----------

  function handleize(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getBreadcrumbData(options = { includeCurrentPage: true }) {
    const breadcrumbItems = document.querySelectorAll('.breadcrumb__item');
    const breadcrumbs = [];

    // eslint-disable-next-line no-unused-vars
    breadcrumbItems.forEach((item, index) => {
      // Try to get link first
      const link = item.querySelector('a');
      let url = null;
      let text = null;
      let hasLink = false;

      if (link) {
        url = link.getAttribute('href');
        text = link.textContent.trim();
        hasLink = true;
      } else {
        // No link - this is likely the current page (last breadcrumb)
        text = item.textContent.trim();
        // Use current page URL as the url
        url = window.location.pathname;
        hasLink = false;
      }

      // Only include items without links if includeCurrentPage is true
      if (text && (hasLink || options.includeCurrentPage)) {
        breadcrumbs.push({
          url,
          text,
          handle: handleize(text),
          hasLink: hasLink,
        });
      }
    });

    return breadcrumbs;
  }

  function highlightParentMenus(link) {
    // Secondary nav list (used for mapping to level-1)
    const secondaryNavContainer = link.closest('.secondary-nav .list-menu');
    if (secondaryNavContainer) {
      const parentHandle = secondaryNavContainer.getAttribute('data-parent');
      if (parentHandle) {
        level1MenuItems.forEach((item) => {
          if (item.getAttribute('data-id') === parentHandle) {
            const span = item.querySelector('span');
            if (span) span.classList.add('header__active-menu-item');
          }
        });
      }
    }

    // Mega menu list (also maps back to level-1 / level-2)
    const megaMenuList = link.closest('.mega-menu__list');
    if (megaMenuList) {
      const parentHandle = megaMenuList.getAttribute('data-parent');
      if (parentHandle) {
        const parentSecondaryLink = document.querySelector(
          `.secondary-nav .header__menu-item[data-menu-param="${parentHandle}"]`,
        );
        if (parentSecondaryLink) {
          const span = parentSecondaryLink.querySelector('span');
          if (span) span.classList.add('header__active-menu-item');
        }

        level1MenuItems.forEach((item) => {
          if (item.getAttribute('data-id') === parentHandle) {
            const span = item.querySelector('span');
            if (span) span.classList.add('header__active-menu-item');
          }
        });
      }
    }
  }

  function highlightLevel1FromDataParent() {
    const globalNavigation = document.querySelector('#menu-global-navigation');
    const globalLevel2Items = globalNavigation.querySelectorAll(
      'a[data-link-text="menu:level3:groupedLinks"], ' + 'summary[data-link-text="menu:level2:open"]',
    );
    let parentDataValue;
    globalLevel2Items.forEach((level2Item) => {
      if (level2Item.classList.contains('menu-drawer__menu-item--active')) {
        if (level2Item.getAttribute('data-link-text') == 'menu:level3:groupedLinks') {
          let parentDataAttr = level2Item.parentElement.parentElement;
          parentDataValue = parentDataAttr.getAttribute('data-parent');
        } else if (level2Item.getAttribute('data-link-text') == 'menu:level2:open') {
          let parentDataAttr = level2Item.parentElement.parentElement.parentElement;
          parentDataValue = parentDataAttr.getAttribute('data-parent');
        }
        mobileLevel1Links.forEach((level1Item) => {
          let level1MenuLabel = level1Item.textContent.trim();
          level1MenuLabel = handleize(level1MenuLabel);
          if (level1MenuLabel === parentDataValue) {
            if (level1Item.tagName.toLowerCase() === 'summary') {
              level1Item.parentElement.classList.add('has-active-menu-item');
              level1Item.classList.add('menu-drawer__menu-item--active');
            }
          }
        });
      }
    });
  }

  // Special-case: highlight the level-1 item that links to the homepage
  function highlightHomeMenuItem() {
    level1MenuItems.forEach((item) => {
      const link = item.querySelector('a');
      const span = item.querySelector('span');
      if (!link || !span) return;

      const href = link.getAttribute('href') || '';
      try {
        const url = new URL(href, window.location.origin);
        if (url.pathname === '/') {
          span.classList.add('header__active-menu-item');
        }
      } catch {
        // ignore malformed URLs - intentionally empty
      }
    });
  }

  // ---------- Mobile Menu Drawer Highlighting ----------

  function highlightMobileMenuFromStorage() {
    // ALWAYS check for breadcrumbs first
    const breadcrumbs = getBreadcrumbData({ includeCurrentPage: true });

    if (breadcrumbs.length > 0) {
      clearNavigationStorage();
      return highlightMobileMenuFromBreadcrumbs();
    }

    const storedState = getStoredMenuState();
    const hasStoredState = !!(storedState.menu || storedState.submenu || storedState.parent);

    if (!hasStoredState) {
      return false;
    }

    let found = false;
    const storedUrl = storedState.url;
    const currentPath = window.location.pathname;

    // Match logic based on what's stored
    mobileMenuLinks.forEach((link) => {
      let linkType = link.getAttribute('data-link-text');
      let linkHref = link.getAttribute('href');
      const linkMenuParam = link.getAttribute('data-menu-param');
      const linkSubmenuParam = link.getAttribute('data-submenu-param');
      const linkMenuHeaderParam = link.getAttribute('data-menuheader-param');

      if (linkType && linkType.includes(':open')) {
        linkType = linkType.replace(':open', '');
      }

      // Handle summary tags - they might not have href directly
      const isSummary = link.tagName.toLowerCase() === 'summary';
      if (isSummary && !linkHref) {
        const details = link.closest('details');
        if (details) {
          const innerLink = details.querySelector(`a[data-link-text="${linkType}"][href]`);
          if (innerLink) {
            linkHref = innerLink.getAttribute('href');
          }
        }
      }

      // For summary tags, href is optional - we can match by data attributes alone
      // For regular links, href is required
      if (!isSummary && !linkHref) return;

      // Get link path for URL comparison (if href exists)
      let linkPath = null;
      if (linkHref) {
        try {
          const linkUrl = new URL(linkHref, window.location.origin);
          linkPath = linkUrl.pathname;
        } catch {
          linkPath = linkHref;
        }
      }

      // Match logic: Highlight items at ALL levels that match the stored state
      const urlMatches = isSummary || !storedUrl || !linkPath || linkPath === storedUrl || linkPath === currentPath;

      // Level 4 matching - FIXED VERSION with more lenient context matching
      if (storedState.submenu && linkType === 'menu:level4:groupedLinks') {
        const linkHandleMatch = handleize(link.textContent.trim()) === storedState.submenu;
        const submenuParamMatch = linkSubmenuParam === storedState.submenu;

        if (submenuParamMatch || linkHandleMatch) {
          // Verify parent context if available - be more lenient with matching
          let contextMatches = true;

          // Only fail context check if BOTH are present and DON'T match
          if (storedState.parent && storedState.parent !== 'featured') {
            if (linkMenuHeaderParam && linkMenuHeaderParam !== storedState.parent) {
              contextMatches = false;
            }
          }

          if (storedState.menu) {
            if (linkMenuParam && linkMenuParam !== storedState.menu) {
              contextMatches = false;
            }
          }

          if (contextMatches && urlMatches) {
            link.classList.add('menu-drawer__menu-item--active');
            link.parentElement.classList.add('has-active-menu-item');
            found = true;
          }
        }
      }

      // Level 3 matching
      if (
        storedState.parent &&
        storedState.parent !== 'featured' &&
        (linkType === 'menu:level3:groupedLinks' || linkType === 'menu:level3')
      ) {
        const linkHandle = handleize(link.textContent.trim());
        const handleMatch = linkHandle === storedState.parent;
        const paramMatch = linkSubmenuParam === storedState.parent;

        if (handleMatch || paramMatch) {
          // Verify menu context if available
          let contextMatches = true;
          if (storedState.menu && linkMenuParam) {
            if (linkMenuParam !== storedState.menu) {
              contextMatches = false;
            }
          }

          if (contextMatches && urlMatches) {
            link.classList.add('menu-drawer__menu-item--active');
            link.parentElement.classList.add('has-active-menu-item');
            found = true;
          }
        }
      }

      // Level 2 matching
      if (linkType === 'menu:level2') {
        const linkHandle = handleize(link.textContent.trim());
        const paramMatch = linkMenuParam === storedState.menu;
        const handleMatch = linkHandle === storedState.menu;

        // Also check if this Level 2 item matches the parent (for nested structures)
        const parentHandleMatch = storedState.parent && linkHandle === storedState.parent;
        const parentParamMatch = storedState.parent && linkSubmenuParam === storedState.parent;

        if (paramMatch || handleMatch || parentHandleMatch || parentParamMatch) {
          if (urlMatches) {
            link.classList.add('menu-drawer__menu-item--active');
            link.parentElement.classList.add('has-active-menu-item');
            found = true;
          }
        }
      }

      // Level 1 matching
      if (linkType === 'menu:level1' || linkType === 'menu:level1:open') {
        const linkHandle = handleize(link.textContent.trim());
        const handleMatch = linkHandle === storedState.menu;
        const paramMatch = linkMenuParam === storedState.menu;

        // Match if menu matches (when deeper levels exist)
        if (storedState.menu && (paramMatch || handleMatch)) {
          if (urlMatches) {
            link.classList.add('menu-drawer__menu-item--active');
            link.parentElement.classList.add('has-active-menu-item');
            found = true;
          }
        }
        // OR match by URL when nothing deeper is stored (truly a level 1 page)
        else {
          const urlMatchesExact =
            linkHref && (linkPath === currentPath || linkPath === storedUrl || linkHref === window.location.href);
          const noDeeperLevel = !storedState.menu && !storedState.parent && !storedState.submenu;

          if (urlMatchesExact && noDeeperLevel) {
            link.classList.add('menu-drawer__menu-item--active');
            link.parentElement.classList.add('has-active-menu-item');
            found = true;
          }
        }
      }
    });

    // Highlight level 2 parent items
    const activeLevel2Items = document.querySelectorAll(
      '.menu-drawer__menu-item--active[data-link-text="menu:level2"], ' +
        '.menu-drawer__menu-item--active[data-link-text="menu:level2:open"]',
    );

    activeLevel2Items.forEach((activeLevel2) => {
      // Get parent -> parent -> parent -> parent (4 levels up)
      const parent1 = activeLevel2.parentElement;
      const parent2 = parent1 ? parent1.parentElement : null;
      const parent3 = parent2 ? parent2.parentElement : null;
      const parent4 = parent3 ? parent3.parentElement : null;

      if (parent3 && parent4) {
        // Get the data-attribute value from parent3
        const parent3DataAttr =
          parent3.getAttribute('data-id') ||
          parent3.getAttribute('data-parent') ||
          parent3.getAttribute('data-menu-param');

        if (parent3DataAttr) {
          // Get the anchor tag inside parent4
          const parent4AnchorTag = parent4.querySelector('a');
          const parent4LinkText = parent4AnchorTag?.getAttribute('data-link-text');

          if (parent4LinkText === 'menu:level1') {
            return;
          }

          if (parent4AnchorTag) {
            const parent4AnchorText = parent4AnchorTag.textContent.trim();
            const parent4AnchorHandleized = handleize(parent4AnchorText);
            const dataAttrHandleized = handleize(parent3DataAttr);

            // If they match, add active class to the anchor tag inside parent4
            if (parent4AnchorHandleized === dataAttrHandleized) {
              parent4AnchorTag.classList.add('menu-drawer__menu-item--active');
              found = true;
            }
          }
        }
      }
    });
    return found;
  }

  function highlightMobileMenuFromBreadcrumbs() {
    const breadcrumbs = getBreadcrumbData({ includeCurrentPage: true });

    if (breadcrumbs.length === 0) {
      return false;
    }

    // Clear existing mobile highlights
    mobileMenuLinks.forEach((link) => {
      link.classList.remove('menu-drawer__menu-item--active');
      link.parentElement.classList.remove('has-active-menu-item');
    });

    const currentPath = window.location.pathname;
    let found = false;

    // Get all breadcrumb handles for validation
    const breadcrumbHandles = breadcrumbs.map((bc) => bc.handle);

    // Track what we find to update session storage
    let detectedMenuState = null;
    let detectedParentState = null;
    let detectedSubmenuState = null;

    // Iterate through ALL breadcrumbs to highlight all levels
    // eslint-disable-next-line no-unused-vars
    breadcrumbs.forEach((crumb, crumbIndex) => {
      const crumbTextLower = crumb.text.toLowerCase();
      const crumbHandle = crumb.handle;
      const crumbUrl = crumb.url;

      // Try to match by URL first (most precise)
      for (const link of mobileMenuLinks) {
        // Skip level 1 menu items
        let linkType = link.getAttribute('data-link-text');
        if (linkType && linkType.includes(':open')) {
          linkType = linkType.replace(':open', '');
        }
        if (linkType === 'menu:level1') {
          continue;
        }

        let linkHref = link.getAttribute('href');

        // Handle summary tags
        const isSummary = link.tagName.toLowerCase() === 'summary';
        if (isSummary && !linkHref) {
          const details = link.closest('details');
          if (details) {
            const innerLink = details.querySelector(`a[href]`);
            if (innerLink) {
              linkHref = innerLink.getAttribute('href');
            }
          }
        }

        if (!linkHref) continue;

        let linkPath = null;
        try {
          const linkUrl = new URL(linkHref, window.location.origin);
          linkPath = linkUrl.pathname;
        } catch {
          linkPath = linkHref;
        }

        if (linkHref === crumbUrl || linkPath === currentPath || linkPath === crumbUrl) {
          // Get hierarchy params
          const linkMenuParam = link.getAttribute('data-menu-param');
          const linkSubmenuParam = link.getAttribute('data-submenu-param');
          const linkMenuHeaderParam = link.getAttribute('data-menuheader-param');

          // Check if this link's hierarchy matches the breadcrumb context
          let contextMatches = true;

          // If link has menu param, check if it matches any breadcrumb
          if (linkMenuParam) {
            const handleizedMenuParam = handleize(linkMenuParam);
            if (!breadcrumbHandles.includes(handleizedMenuParam)) {
              contextMatches = false;
            }
          }

          // If link has submenu param, check if it matches any breadcrumb (for level 3 and level 4)
          if (linkSubmenuParam && contextMatches) {
            const handleizedSubmenuParam = handleize(linkSubmenuParam);
            if (!breadcrumbHandles.includes(handleizedSubmenuParam)) {
              contextMatches = false;
            }
          }

          // If link has menuheader param, check if it matches any breadcrumb
          if (linkMenuHeaderParam && contextMatches) {
            const handleizedMenuHeaderParam = handleize(linkMenuHeaderParam);
            if (!breadcrumbHandles.includes(handleizedMenuHeaderParam)) {
              contextMatches = false;
            }
          }

          // Also check if the link's text matches the current breadcrumb
          const linkTextLower = link.textContent.trim().toLowerCase();
          if (linkTextLower === crumb.text.toLowerCase()) {
            contextMatches = true;
          }

          if (contextMatches) {
            link.classList.add('menu-drawer__menu-item--active');
            link.parentElement.classList.add('has-active-menu-item');
            found = true;

            // Store the navigation state based on link type
            if (linkType === 'menu:level2') {
              if (linkMenuParam) {
                detectedMenuState = linkMenuParam;
              }
            } else if (linkType === 'menu:level3:groupedLinks' || linkType === 'menu:level3') {
              if (linkSubmenuParam) {
                detectedParentState = linkSubmenuParam;
              } else {
                detectedParentState = handleize(link.textContent.trim());
              }
              if (linkMenuParam) {
                detectedMenuState = linkMenuParam;
              }
            } else if (linkType === 'menu:level4:groupedLinks') {
              if (linkSubmenuParam) {
                detectedSubmenuState = linkSubmenuParam;
              } else {
                detectedSubmenuState = handleize(link.textContent.trim());
              }
              if (linkMenuHeaderParam) {
                detectedParentState = linkMenuHeaderParam;
              }
              if (linkMenuParam) {
                detectedMenuState = linkMenuParam;
              }
            }
          }
        }
      }

      // Try text match for this breadcrumb
      for (const link of mobileMenuLinks) {
        // Skip level 1 menu items
        let linkType = link.getAttribute('data-link-text');
        if (linkType && linkType.includes(':open')) {
          linkType = linkType.replace(':open', '');
        }
        if (linkType === 'menu:level1') {
          continue;
        }

        const linkTextLower = link.textContent.trim().toLowerCase();
        if (linkTextLower === crumbTextLower) {
          link.classList.add('menu-drawer__menu-item--active');
          link.parentElement.classList.add('has-active-menu-item');
          found = true;

          // Store the navigation state
          const linkMenuParam = link.getAttribute('data-menu-param');
          const linkSubmenuParam = link.getAttribute('data-submenu-param');
          const linkMenuHeaderParam = link.getAttribute('data-menuheader-param');

          if (linkType === 'menu:level2' && linkMenuParam) {
            detectedMenuState = linkMenuParam;
          } else if (linkType === 'menu:level3:groupedLinks' || linkType === 'menu:level3') {
            detectedParentState = linkSubmenuParam || handleize(link.textContent.trim());
            if (linkMenuParam) detectedMenuState = linkMenuParam;
          } else if (linkType === 'menu:level4:groupedLinks') {
            detectedSubmenuState = linkSubmenuParam || handleize(link.textContent.trim());
            if (linkMenuHeaderParam) detectedParentState = linkMenuHeaderParam;
            if (linkMenuParam) detectedMenuState = linkMenuParam;
          }
        }
      }

      // Try handle match for this breadcrumb
      if (crumbHandle) {
        for (const link of mobileMenuLinks) {
          // Skip level 1 menu items
          let linkType = link.getAttribute('data-link-text');
          if (linkType && linkType.includes(':open')) {
            linkType = linkType.replace(':open', '');
          }
          if (linkType === 'menu:level1') {
            continue;
          }

          const linkHandle = handleize(link.textContent.trim());
          if (linkHandle === crumbHandle) {
            link.classList.add('menu-drawer__menu-item--active');
            link.parentElement.classList.add('has-active-menu-item');
            found = true;

            // Store the navigation state
            const linkMenuParam = link.getAttribute('data-menu-param');
            const linkSubmenuParam = link.getAttribute('data-submenu-param');
            const linkMenuHeaderParam = link.getAttribute('data-menuheader-param');

            if (linkType === 'menu:level2' && linkMenuParam) {
              detectedMenuState = linkMenuParam;
            } else if (linkType === 'menu:level3:groupedLinks' || linkType === 'menu:level3') {
              detectedParentState = linkSubmenuParam || handleize(link.textContent.trim());
              if (linkMenuParam) detectedMenuState = linkMenuParam;
            } else if (linkType === 'menu:level4:groupedLinks') {
              detectedSubmenuState = linkSubmenuParam || handleize(link.textContent.trim());
              if (linkMenuHeaderParam) detectedParentState = linkMenuHeaderParam;
              if (linkMenuParam) detectedMenuState = linkMenuParam;
            }
          }
        }
      }
    });

    // Update session storage based on what we found
    if (found) {
      // Only store what we actually found
      if (detectedMenuState) {
        saveMenuState(detectedMenuState);
      }
      if (detectedParentState) {
        sessionStorage.setItem(STORAGE_KEYS.ACTIVE_MENU_PARENT, detectedParentState);
      }
      if (detectedSubmenuState) {
        sessionStorage.setItem(STORAGE_KEYS.ACTIVE_SUBMENU, detectedSubmenuState);
      }

      // Always store the current URL
      sessionStorage.setItem(STORAGE_KEYS.ACTIVE_URL, currentPath);
    }
    return found;
  }

  // ---------- Desktop Navigation Highlighting ----------

  function highlightFromSessionStorage() {
    const storedState = getStoredMenuState();
    let found = false;

    // Restore level-2 menu highlighting
    if (storedState.menu) {
      secondaryNavLinks.forEach((link) => {
        const linkType = link.getAttribute('data-link-text');
        if (linkType === 'menu:level2') {
          const linkHandle = handleize(link.textContent.trim());
          const span = link.querySelector('span');

          if (linkHandle === storedState.menu && span) {
            span.classList.add('header__active-menu-item');
            highlightParentMenus(link);
            found = true;
          }
        }
      });
    }

    // Restore submenu (level 3/4) highlighting
    if (storedState.submenu) {
      if (storedState.parent === 'featured') {
        secondaryNavLinks.forEach((link) => {
          const linkType = link.getAttribute('data-link-text');
          if (linkType === 'menu:level3:featuredLinks') {
            const linkHandle = handleize(link.textContent.trim());

            if (linkHandle === storedState.submenu) {
              link.classList.add('mega-menu__link--active');
              highlightParentMenus(link);
              found = true;
            }
          }
        });
      } else {
        secondaryNavLinks.forEach((link) => {
          const linkType = link.getAttribute('data-link-text');
          if (linkType === 'menu:level4:groupedLinks') {
            const linkHandle = handleize(link.textContent.trim());
            const linkMenuHeaderParam = link.getAttribute('data-menuheader-param');

            if (linkHandle === storedState.submenu) {
              if (storedState.parent && storedState.parent !== 'featured') {
                if (linkMenuHeaderParam === storedState.parent) {
                  link.classList.add('mega-menu__link--active');
                  highlightParentMenus(link);
                  found = true;
                }
              } else {
                link.classList.add('mega-menu__link--active');
                highlightParentMenus(link);
                found = true;
              }
            }
          }
        });
      }
    } else if (storedState.parent && storedState.parent !== 'featured') {
      secondaryNavLinks.forEach((link) => {
        const linkType = link.getAttribute('data-link-text');
        if (linkType && linkType.includes('level3') && linkType !== 'menu:level2') {
          const linkHandle = handleize(link.textContent.trim());

          if (linkHandle === storedState.parent) {
            link.classList.add('mega-menu__link--active');
            highlightParentMenus(link);
            found = true;
          }
        }
      });
    }

    return found;
  }

  function highlightFromBreadcrumbs() {
    const breadcrumbs = getBreadcrumbData({ includeCurrentPage: false });
    if (breadcrumbs.length === 0) return false;

    const crumb = breadcrumbs[breadcrumbs.length - 1];
    const crumbTextLower = crumb.text.toLowerCase();
    const crumbHandle = crumb.handle;
    const crumbUrl = crumb.url;

    let found = false;

    const activateLink = (link, opts = { asLevel2: false }) => {
      const span = link.querySelector('span');
      if (opts.asLevel2 && span) {
        span.classList.add('header__active-menu-item');
      } else {
        link.classList.add('mega-menu__link--active');
      }
      highlightParentMenus(link);
      found = true;
    };

    for (const link of secondaryNavLinks) {
      const linkUrl = link.getAttribute('href');
      if (linkUrl && linkUrl === crumbUrl) {
        const isLevel2 = link.getAttribute('data-link-text') === 'menu:level2';
        activateLink(link, { asLevel2: isLevel2 });
        break;
      }
    }

    if (!found) {
      for (const link of megaMenuQuickLinks) {
        const linkUrl = link.getAttribute('href');
        if (linkUrl && linkUrl === crumbUrl) {
          activateLink(link, { asLevel2: false });
          break;
        }
      }
    }

    if (!found) {
      for (const link of secondaryNavLinks) {
        const linkTextLower = link.textContent.trim().toLowerCase();
        if (linkTextLower === crumbTextLower) {
          const isLevel2 = link.getAttribute('data-link-text') === 'menu:level2';
          activateLink(link, { asLevel2: isLevel2 });
          break;
        }
      }
    }

    if (!found) {
      for (const link of megaMenuQuickLinks) {
        const linkTextLower = link.textContent.trim().toLowerCase();
        if (linkTextLower === crumbTextLower) {
          activateLink(link, { asLevel2: false });
          break;
        }
      }
    }

    if (!found && crumbHandle) {
      for (const link of secondaryNavLinks) {
        const linkHandle = handleize(link.textContent.trim());
        if (linkHandle === crumbHandle) {
          const isLevel2 = link.getAttribute('data-link-text') === 'menu:level2';
          activateLink(link, { asLevel2: isLevel2 });
          break;
        }
      }
    }

    if (!found && crumbHandle) {
      for (const link of megaMenuQuickLinks) {
        const linkHandle = handleize(link.textContent.trim());
        if (linkHandle === crumbHandle) {
          activateLink(link, { asLevel2: false });
          break;
        }
      }
    }

    return found;
  }

  function waitForBreadcrumbs(callback, maxAttempts = 50, attempt = 1) {
    const breadcrumbItems = document.querySelectorAll('.breadcrumb__item a');
    if (breadcrumbItems.length > 0) {
      callback();
    } else if (attempt < maxAttempts) {
      setTimeout(() => {
        waitForBreadcrumbs(callback, maxAttempts, attempt + 1);
      }, 100); // Check every 100ms instead of 200ms
    } else {
      // After max attempts, still run callback but storage won't be cleared
      callback();
    }
  }

  function observeBreadcrumbs(callback) {
    const breadcrumbContainer = document.querySelector('.breadcrumb, nav[aria-label*="breadcrumb"], .breadcrumbs');

    if (!breadcrumbContainer) {
      waitForBreadcrumbs(callback);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          const breadcrumbItems = document.querySelectorAll('.breadcrumb__item a');
          if (breadcrumbItems.length > 0) {
            observer.disconnect();
            callback();
            break;
          }
        }
      }
    });

    observer.observe(breadcrumbContainer, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
      callback();
    }, 3000);
  }

  // ---------- URL param management on desktop links ----------

  secondaryNavLinks.forEach((link) => {
    const baseUrl = link.getAttribute('href');
    const menuParam = link.getAttribute('data-menu-param');
    const submenuParam = link.getAttribute('data-submenu-param');
    const menuheaderParam = link.getAttribute('data-menuheader-param');

    const addParametersToHref = () => {
      const url = new URL(baseUrl, window.location.origin);
      if (menuParam) url.searchParams.set('menu', menuParam);
      if (submenuParam) url.searchParams.set('submenu', submenuParam);
      if (menuheaderParam) url.searchParams.set('menuheader', menuheaderParam);
      link.setAttribute('href', url.toString());
    };

    const restoreCleanHref = () => {
      link.setAttribute('href', baseUrl);
    };

    link.addEventListener('mouseenter', addParametersToHref);
    link.addEventListener('mouseleave', restoreCleanHref);

    link.addEventListener('click', function () {
      addParametersToHref();

      const linkType = link.getAttribute('data-link-text');
      const linkHandle = handleize(link.textContent.trim());
      const linkUrl = link.getAttribute('href');

      try {
        const url = new URL(linkUrl, window.location.origin);
        sessionStorage.setItem(STORAGE_KEYS.ACTIVE_URL, url.pathname);
        // eslint-disable-next-line no-unused-vars
      } catch (e) {
        sessionStorage.setItem(STORAGE_KEYS.ACTIVE_URL, linkUrl);
      }
      sessionStorage.setItem(STORAGE_KEYS.ACTIVE_LINK_TYPE, linkType);

      if (linkType === 'menu:level2') {
        saveMenuState(menuParam || linkHandle);
        // Keep existing submenu/parent storage - don't clear it
        // It will be updated on the next page if needed
      } else if (linkType === 'menu:level3:groupedLinks' || linkType === 'menu:level3:quickLinks') {
        sessionStorage.setItem(STORAGE_KEYS.ACTIVE_MENU_PARENT, linkHandle);
        // Keep existing submenu storage
        if (menuParam) {
          saveMenuState(menuParam);
        }
      } else if (linkType === 'menu:level3:featuredLinks') {
        sessionStorage.setItem(STORAGE_KEYS.ACTIVE_SUBMENU, linkHandle);
        sessionStorage.setItem(STORAGE_KEYS.ACTIVE_MENU_PARENT, 'featured');
        if (menuParam) {
          saveMenuState(menuParam);
        }
      } else if (linkType === 'menu:level4:groupedLinks') {
        sessionStorage.setItem(STORAGE_KEYS.ACTIVE_SUBMENU, submenuParam || linkHandle);
        if (menuheaderParam) {
          sessionStorage.setItem(STORAGE_KEYS.ACTIVE_MENU_PARENT, menuheaderParam);
        }
        if (menuParam) {
          saveMenuState(menuParam);
        }
      }
    });

    link.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        addParametersToHref();
        const linkType = link.getAttribute('data-link-text');
        const linkHandle = handleize(link.textContent.trim());

        if (linkType === 'menu:level2') {
          saveMenuState(menuParam || linkHandle);
          // Keep existing submenu/parent storage
        } else if (linkType === 'menu:level3:groupedLinks' || linkType === 'menu:level3:quickLinks') {
          sessionStorage.setItem(STORAGE_KEYS.ACTIVE_MENU_PARENT, linkHandle);
          if (menuParam) saveMenuState(menuParam);
        } else if (linkType === 'menu:level3:featuredLinks') {
          sessionStorage.setItem(STORAGE_KEYS.ACTIVE_SUBMENU, linkHandle);
          sessionStorage.setItem(STORAGE_KEYS.ACTIVE_MENU_PARENT, 'featured');
          if (menuParam) saveMenuState(menuParam);
        } else if (linkType === 'menu:level4:groupedLinks') {
          sessionStorage.setItem(STORAGE_KEYS.ACTIVE_SUBMENU, submenuParam || linkHandle);
          if (menuheaderParam) sessionStorage.setItem(STORAGE_KEYS.ACTIVE_MENU_PARENT, menuheaderParam);
          if (menuParam) saveMenuState(menuParam);
        }
      }
    });
  });

  megaMenuQuickLinks.forEach((link) => {
    link.addEventListener('click', function () {
      const linkHandle = handleize(link.textContent.trim());
      saveSubmenuState(linkHandle, null);
    });

    link.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        const linkHandle = handleize(link.textContent.trim());
        saveSubmenuState(linkHandle, null);
      }
    });
  });

  // ---------- Mobile Menu Click Handlers ----------

  mobileMenuLinks.forEach((link) => {
    link.addEventListener('click', function () {
      const linkText = link.textContent.trim();
      const linkHandle = handleize(linkText);
      let linkType = link.getAttribute('data-link-text');
      let linkHref = link.getAttribute('href');

      const menuParam = link.getAttribute('data-menu-param');
      const submenuParam = link.getAttribute('data-submenu-param');
      const menuheaderParam = link.getAttribute('data-menuheader-param');

      // Normalize linkType - remove :open suffix
      if (linkType && linkType.includes(':open')) {
        linkType = linkType.replace(':open', '');
      }

      // For summary tags, we need to find the associated href
      const isSummary = link.tagName.toLowerCase() === 'summary';

      if (isSummary) {
        const details = link.closest('details');
        if (details) {
          const innerLink = details.querySelector(`a[data-link-text="${linkType}"][href]`);
          if (innerLink) {
            linkHref = innerLink.getAttribute('href');
          }
        }
      }

      // Skip if no href and not a summary
      if (!linkHref && !isSummary) return;

      // Save to session storage based on level
      if (linkType === 'menu:level1') {
        // Level 1 - clear all other storage
        clearNavigationStorage();
        // Store URL for level 1
        if (linkHref) {
          try {
            const url = new URL(linkHref, window.location.origin);
            sessionStorage.setItem(STORAGE_KEYS.ACTIVE_URL, url.pathname);
            // eslint-disable-next-line no-unused-vars
          } catch (e) {
            sessionStorage.setItem(STORAGE_KEYS.ACTIVE_URL, linkHref);
          }
        }
      } else if (linkType === 'menu:level2') {
        // Level 2 - save menu, but CLEAR submenu and parent (child levels)
        saveMenuState(menuParam || linkHandle);
        // Clear child levels
        sessionStorage.removeItem(STORAGE_KEYS.ACTIVE_SUBMENU);
        sessionStorage.removeItem(STORAGE_KEYS.ACTIVE_MENU_PARENT);
      } else if (linkType === 'menu:level3' || linkType === 'menu:level3:groupedLinks') {
        // Level 3 - save parent, clear submenu (child level)
        sessionStorage.setItem(STORAGE_KEYS.ACTIVE_MENU_PARENT, submenuParam || linkHandle);
        // Clear child level
        sessionStorage.removeItem(STORAGE_KEYS.ACTIVE_SUBMENU);
        // Keep menu if available
        if (menuParam) saveMenuState(menuParam);
      } else if (linkType === 'menu:level4:groupedLinks') {
        // Level 4 - save everything (deepest level)
        sessionStorage.setItem(STORAGE_KEYS.ACTIVE_SUBMENU, submenuParam || linkHandle);
        if (menuheaderParam) sessionStorage.setItem(STORAGE_KEYS.ACTIVE_MENU_PARENT, menuheaderParam);
        if (menuParam) saveMenuState(menuParam);
      }

      // Store URL if available
      if (linkHref) {
        try {
          const url = new URL(linkHref, window.location.origin);
          sessionStorage.setItem(STORAGE_KEYS.ACTIVE_URL, url.pathname);
          // eslint-disable-next-line no-unused-vars
        } catch (e) {
          sessionStorage.setItem(STORAGE_KEYS.ACTIVE_URL, linkHref);
        }
      }
    });
  });

  // Clear storage when level-1 items are clicked
  level1MenuItems.forEach((item) => {
    item.addEventListener('click', function () {
      clearNavigationStorage();
    });
  });

  mobileLevel1Links.forEach((link) => {
    link.addEventListener('click', function () {
      clearNavigationStorage();
    });
  });

  // ---------- Core highlight logic ----------

  function handleNavigationHighlighting() {
    if (initialHighlightDone && hadMenuParamsOnLoad) {
      return;
    }

    if (isProcessing) return;
    isProcessing = true;

    try {
      if (shouldClearStorageForUrlMismatch()) {
        clearNavigationStorage();
      }

      const isHomePath =
        window.location.pathname === '/' || window.location.pathname === '' || window.location.pathname === '/index';

      // Parse URL params once
      const urlParams = new URLSearchParams(window.location.search);
      const clickedMenu = urlParams.get('menu');
      const clickedSubmenu = urlParams.get('submenu');
      const menuheader = urlParams.get('menuheader');
      const hasParams = !!(clickedMenu || clickedSubmenu || menuheader);

      // Build lookup maps for O(1) access instead of nested loops
      const level1ItemsMap = new Map();
      level1MenuItems.forEach((item) => {
        const id = item.getAttribute('data-id');
        if (id) level1ItemsMap.set(id, item.querySelector('span'));
      });

      // Pre-highlight active subnav links
      subnavLinks.forEach((link) => {
        if (link.classList.contains('active')) {
          const linkParent = link.closest('.proxy-subnav')?.getAttribute('data-parent');
          if (linkParent) {
            const span = level1ItemsMap.get(linkParent);
            if (span) span.classList.add('header__active-menu-item');
          }
        }
      });

      // Clear mega menu links once
      megaMenuQuickLinks.forEach((link) => link.classList.remove('mega-menu__link--active'));

      // Desktop param-driven highlighting
      if (clickedSubmenu) {
        for (const link of secondaryNavLinks) {
          if (link.getAttribute('data-link-text') === 'menu:level2') continue;

          const linkSubmenuParam = link.getAttribute('data-submenu-param');
          const linkMenuParam = link.getAttribute('data-menu-param');

          if (linkSubmenuParam === clickedSubmenu && linkMenuParam === clickedMenu) {
            const linkMenuHeaderParam = link.getAttribute('data-menuheader-param');

            if ((menuheader && linkMenuHeaderParam === menuheader) || (!menuheader && !linkMenuHeaderParam)) {
              link.classList.add('mega-menu__link--active');
              highlightParentMenus(link);
              saveSubmenuState(clickedSubmenu, menuheader || null);
              break; // Found match, exit early
            }
          }
        }
      }

      if (clickedMenu) {
        for (const link of secondaryNavLinks) {
          const linkType = link.getAttribute('data-link-text');
          if (linkType !== 'menu:level2') continue;

          const linkMenuParam = link.getAttribute('data-menu-param');
          if (linkMenuParam === clickedMenu) {
            const linkSpan = link.querySelector('span');
            if (linkSpan) {
              linkSpan.classList.add('header__active-menu-item');

              const linkSpanParent = link.closest('.secondary-nav .list-menu')?.getAttribute('data-parent');
              if (linkSpanParent) {
                const span = level1ItemsMap.get(linkSpanParent);
                if (span) span.classList.add('header__active-menu-item');
              }

              saveMenuState(clickedMenu);
              break; // Found match, exit early
            }
          }
        }
      }

      // No params – use session storage or breadcrumbs
      if (!hasParams) {
        const restoredFromStorage = highlightFromSessionStorage();

        if (!restoredFromStorage) {
          if (isHomePath) {
            highlightHomeMenuItem();
          } else {
            highlightFromBreadcrumbs();
          }
        }
      }

      // Ensure active leaf activates level-2 parent (optimize with early exit)
      for (const link of secondaryNavLinks) {
        if (link.classList.contains('mega-menu__link--active')) {
          const parentHandle = link.getAttribute('data-menu-param');
          if (parentHandle) {
            const parentLevel2 = document.querySelector(
              `.secondary-nav .list-menu .header__menu-item[data-link-text="menu:level2"][data-menu-param="${parentHandle}"]`,
            );
            if (parentLevel2) {
              const span = parentLevel2.querySelector('span');
              if (span) span.classList.add('header__active-menu-item');
            }
          }
        }
      }

      // Quick link parent activation (optimize with early exit)
      for (const link of megaMenuQuickLinks) {
        if (link.classList.contains('mega-menu__link--active')) {
          const linkParent = link.closest('.secondary-nav .mega-menu__list')?.getAttribute('data-parent');
          if (linkParent) {
            const span = level1ItemsMap.get(linkParent);
            if (span) span.classList.add('header__active-menu-item');
          }
        }
      }

      // MOBILE HIGHLIGHTING
      if (!hasParams) {
        const mobileHighlighted = highlightMobileMenuFromStorage();
        if (!mobileHighlighted && !isHomePath) {
          highlightMobileMenuFromBreadcrumbs();
        }
      }

      // Strip URL params after first highlight
      if (!initialHighlightDone && hadMenuParamsOnLoad) {
        const cleanUrl = new URL(window.location);
        cleanUrl.searchParams.delete('menu');
        cleanUrl.searchParams.delete('submenu');
        cleanUrl.searchParams.delete('menuheader');
        window.history.replaceState({}, document.title, cleanUrl.toString());
      }

      if (hadMenuParamsOnLoad) {
        initialHighlightDone = true;
      }

      document.dispatchEvent(new Event('menuUpdated'));
    } finally {
      isProcessing = false;
    }
  }

  // Call immediately without any delays
  handleNavigationHighlighting();

  // eslint-disable-next-line no-unused-vars
  window.addEventListener('pageshow', function (event) {
    navigationCount++;
    if (navigationCount > 1) {
      handleNavigationHighlighting();
    }
  });

  window.addEventListener('popstate', function () {
    handleNavigationHighlighting();
  });

  if (hadMenuParamsOnLoad) {
    handleNavigationHighlighting();
  } else {
    const storedState = getStoredMenuState();

    if (storedState.menu || storedState.submenu) {
      handleNavigationHighlighting();
    } else {
      observeBreadcrumbs(handleNavigationHighlighting);
      highlightLevel1FromDataParent();
    }
  }
  // Navigation tracking to clear storage when going outside menu systems
  function isNavigationFromMenuSystem(event) {
    if (!event || !event.target) return false;

    const target = event.target;

    const inMobileMenu = target.closest('.menu-drawer, .menu-drawer__menu-item, .menu-drawer__navigation');
    const inDesktopMenu = target.closest('.secondary-nav, .mega-menu, .header__menu-item, .proxy-subnav');
    const inLevel1Menu = target.closest('[data-link-text="menu:level1"]');

    return !!(inMobileMenu || inDesktopMenu || inLevel1Menu);
  }

  function isHomepageUrl(url) {
    // Check if URL is homepage
    let path;
    try {
      const urlObj = new URL(url, window.location.origin);
      path = urlObj.pathname;
    } catch {
      path = url;
    }

    return path === '/' || path === '' || path === '/index' || path === '/index.html';
  }

  function shouldClearStorageOnNavigation(targetUrl) {
    // ALWAYS clear storage when navigating to homepage
    if (isHomepageUrl(targetUrl)) {
      return true;
    }

    const allMenuLinks = document.querySelectorAll(
      '.menu-drawer__menu-item[href], ' +
        '.secondary-nav a[href], ' +
        '.mega-menu__link[href], ' +
        '.header__menu-item a[href]',
    );

    let targetPath;
    try {
      const url = new URL(targetUrl, window.location.origin);
      targetPath = url.pathname;
    } catch {
      targetPath = targetUrl;
    }

    for (const link of allMenuLinks) {
      const linkHref = link.getAttribute('href');
      if (!linkHref) continue;

      let linkPath;
      try {
        const url = new URL(linkHref, window.location.origin);
        linkPath = url.pathname;
      } catch {
        linkPath = linkHref;
      }

      if (linkPath === targetPath) {
        return false;
      }
    }

    return true;
  }

  document.addEventListener(
    'click',
    function (event) {
      const link = event.target.closest('a[href]');

      if (!link) return;

      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

      // Check if navigating to homepage
      if (isHomepageUrl(href)) {
        clearNavigationStorage();
        return;
      }

      const fromMenu = isNavigationFromMenuSystem(event);

      if (fromMenu) {
        return;
      }

      const shouldClear = shouldClearStorageOnNavigation(href);

      if (shouldClear) {
        clearNavigationStorage();
      }
    },
    true,
  );

  let lastKnownPath = window.location.pathname;

  window.addEventListener('popstate', function () {
    const currentPath = window.location.pathname;

    if (currentPath !== lastKnownPath) {
      // Check if navigating to homepage
      if (isHomepageUrl(currentPath)) {
        clearNavigationStorage();
        lastKnownPath = currentPath;
        return;
      }

      const shouldClear = shouldClearStorageOnNavigation(currentPath);

      if (shouldClear) {
        clearNavigationStorage();
      }

      lastKnownPath = currentPath;
    }
  });

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function () {
    const result = originalPushState.apply(this, arguments);
    const currentPath = window.location.pathname;

    // Check if navigating to homepage
    if (isHomepageUrl(currentPath)) {
      clearNavigationStorage();
      lastKnownPath = currentPath;
      return result;
    }

    const shouldClear = shouldClearStorageOnNavigation(currentPath);

    if (shouldClear) {
      clearNavigationStorage();
    }

    lastKnownPath = currentPath;
    return result;
  };

  history.replaceState = function () {
    const result = originalReplaceState.apply(this, arguments);
    const currentPath = window.location.pathname;

    // Check if navigating to homepage
    if (isHomepageUrl(currentPath)) {
      clearNavigationStorage();
      lastKnownPath = currentPath;
      return result;
    }

    const shouldClear = shouldClearStorageOnNavigation(currentPath);

    if (shouldClear) {
      clearNavigationStorage();
    }

    lastKnownPath = currentPath;
    return result;
  };
});
